import React from 'react'
import { Link } from 'react-router-dom'
import tw from 'twin.macro'
import styled from 'styled-components'
import { SlDivider } from '@shoelace-style/shoelace/dist/react'
import SocialMediaLinks from 'components/SocialMediaLinks'
import { TvlWidget } from 'components/TvlWidget'
import { useTranslation } from 'contexts/Localization'
import FooterMenu from './FooterMenu'

const StyledLink = styled(Link)`
  ${tw`text-14 text-dark-gray-100 hover:text-blue-500 block py-2`}
`

const StyledSlDivider = styled(SlDivider)`
  ${tw`border-t border-dark-gray-600 my-0 md:my-16`}
`

// TODO: move copyright to separate component and calculate current year
const Footer: React.FC = () => {
  const { t } = useTranslation()

  return (
    <footer className="grid gap-20 md:gap-16 md:grid-cols-2 px-8 py-16 md:px-24 md:py-32">
      <StyledSlDivider className="md:col-span-2" />

      <div className="flex flex-col md:flex-row md:justify-between gap-24 w-full row-start-3 md:row-start-auto">
        <FooterMenu title={t('About')}>
          <ul className="space-y-8">
            <li>
              <StyledLink
                to={{ pathname: 'https://nomiswap.gitbook.io/home/' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('Overview')}
              </StyledLink>
            </li>
            <li>
              <StyledLink
                to={{ pathname: 'https://nomiswap.gitbook.io/home/nominex-nomiswap-ecosystem' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('Ecosystem')}
              </StyledLink>
            </li>
            <li>
              <StyledLink
                to={{ pathname: 'http://nominex.io/docs/nomiswap-whitepaper.pdf' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('Whitepaper')}
              </StyledLink>
            </li>
            <li>
              <StyledLink
                to={{ pathname: 'https://nomiswap.gitbook.io/home/roadmap' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('Roadmap')}
              </StyledLink>
            </li>
            <li>
              <StyledLink
                to={{ pathname: 'https://nomiswap.gitbook.io/home/business-partnerships' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('Business partnerships')}
              </StyledLink>
            </li>
          </ul>
        </FooterMenu>
        <FooterMenu title={t('Features')}>
          <ul className="space-y-8">
            <li>
              <StyledLink to="/swap">{t('Exchange')}</StyledLink>
            </li>
            <li>
              <StyledLink to="/liquidity">{t('Liquidity')}</StyledLink>
            </li>
            <li>
              <StyledLink to="/farms">{t('Farms')}</StyledLink>
            </li>
            <li>
              <StyledLink to="/pools">{t('Launchpools')}</StyledLink>
            </li>
          </ul>
        </FooterMenu>
        <FooterMenu title={t('Extra')}>
          <ul className="space-y-8">
            <li>
              <StyledLink
                to={{ pathname: 'https://nomiswap.gitbook.io/home/core-products/holder-bonus' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('Holder bonus')}
              </StyledLink>
            </li>
            <li>
              <StyledLink
                to={{ pathname: 'https://nomiswap.gitbook.io/home/core-products/token-burning' }}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('NMX burning')}
              </StyledLink>
            </li>
          </ul>
        </FooterMenu>
      </div>

      <div className="flex md:justify-end row-start-2 md:row-start-auto">
        <TvlWidget />
      </div>

      <StyledSlDivider className="md:col-span-2" />

      <div className="flex items-center justify-center md:justify-end">
        <SocialMediaLinks />
      </div>
    </footer>
  )
}

export default Footer
